import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import SuccessMessageUI from '../../../widgets/form/SuccessMessageUI'
import ButtonWithSpinnerUI from '../../../widgets/action/ButtonWithSpinnerUI'
import ClientTxnCategoryListSF from '../clientTxn/ClientTxnCategoryListSF'
import AccountPropertyListSF from '../account/util/AccountPropertyListSF'

const BankAnalyzerUI = ({ context, account, show, onRefreshClick,
  onBankAnalyzerSubmit, bankAnalyzerSubmitted, onKeywordsClick, showKeywords,
  successMsg, errorList,
  propertyValue
}) =>
  <div className='su_ba g_m_top_50'>
    <div className='g_flex_h'>
      {
        show && context.permissions.includes('su_view') &&
        <div className='g_flex_v'>
          <SuccessMessageUI successMsg={successMsg} />
          <div className='g_flex_h '>
            <span className='g_muted g_small'>
              Bank analyzer runs across all bank accounts and financial years.<br/>
              Manually categorized transactions are not updated by bank analyzer.<br/>
              After keywords are updated bank analyzer needs to be rerun.
            </span>
            <a href='#' onClick={onKeywordsClick}>Keywords</a>
            <div className='g_flex_h g_flex_left'>
              <ButtonWithSpinnerUI label='Run Bank Analyzer' onClick={onBankAnalyzerSubmit}
                busy={bankAnalyzerSubmitted}
                disabled={propertyValue == '1'}
              />
            </div>
          </div>
        </div>
      }
    </div>
    {
      showKeywords &&
      <>
        <div className='g_flex_h g_flex_right'>
          <Link to='/su/mappings/bank_analyzer_keywords' className='g_no_wrap'>
            Global bank analyzer keywords
          </Link>
        </div>

        <AccountPropertyListSF context={context} account={account}
          category='bank_analyzer' />
        <ClientTxnCategoryListSF context={context} account={account}
          category='bank_analyzer' categoryLabel='Account specific keywords' />
      </>
    }
  </div>

export default BankAnalyzerUI
